import { compose } from 'lodash/fp'
import withReduxForm from '../withReduxForm'
import CountrySelect from './CountrySelect'
import withRedux from './withRedux'
import withCountries from './withCountries'

export { CountrySelect }

export default compose(
  withReduxForm,
  withCountries,
  withRedux,
)(CountrySelect)
